module.exports = __webpack_public_path__ + "media/img/corporate/first-line-mobile-2d095adf85e8126d9fd73f071c664d29.svg";